import { render, staticRenderFns } from "./suitch-map-widget.vue?vue&type=template&id=52196ec2&scoped=true&"
import script from "./suitch-map-widget.vue?vue&type=script&lang=js&"
export * from "./suitch-map-widget.vue?vue&type=script&lang=js&"
import style0 from "./suitch-map-widget.vue?vue&type=style&index=0&id=52196ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52196ec2",
  null
  
)

export default component.exports